import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import axios from 'axios'
import utils from "@/utils"
import constant from '@/constant'

Vue.config.productionTip = false

async function refreshAccessToken() {

  try {
    // console.log("Attempting token refresh...");

    const refreshResponse = await axios.post(utils._api(constant.refresh), 
      {}, 
      {
        withCredentials: true, // ENSURES COOKIES ARE SENT DURING REQUEST
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          'X-Skip-Token-Refresh': 'true'  // SKIP AXIOS INTERCEPTOR FOR THIS REQUEST
        },
      }
    );

    // console.log("Token refresh response received:", refreshResponse);

    const newAccessToken = refreshResponse.data.access_token;
    const decodedToken = JSON.parse(atob(newAccessToken.split('.')[1]));
    const newExp = decodedToken.exp * 1000;

    // STORE THE NEW TOKEN AND EXPIRATION
    localStorage.setItem('token', newAccessToken);
    localStorage.setItem('token_exp', newExp);

    // console.log("New token and expiration stored in localStorage.");
    return true;
  } catch (error) {
    console.error('Token Refresh Error:', error);
    return false;
  }
}

// AXIOS INTERCEPTOR TO CHECK TOKEN EXPIRATION AND REFRESH IF DEPENDING ON CONDITIONS
axios.interceptors.request.use(
  async (config) => {
    // Skip token refresh during login
    if (config.headers['X-Skip-Token-Refresh']) {
      // console.log('Token refresh skipped due to X-Skip-Token-Refresh header'); 
      return config; // SKIP THE REFRESH PART IF THE HEADERS EXISTS
    }
    
    // GET THE TOKEN AND THE EXP
    const token = localStorage.getItem('token');
    const tokenExp = localStorage.getItem('token_exp');

    // console.log('Intercepting request...');
    // console.log('Token:', token);
    // console.log('Token Expiration:', tokenExp);

    if (token && tokenExp) {
      const now = Date.now();

      // console.log('Current Time:', now);
      // console.log('Token Expiration Difference:', tokenExp - now);

      // IF TOKEN IS SET TO EXPIRE IN 10 MINS, REFRESH IT
        if (tokenExp - now <= 10 * 60 * 1000) { // SET TO 10 MINS
        // console.log('refreshing...')
        const refreshed = await refreshAccessToken();
        if (!refreshed) {
          // console.log('token refersh failed')
          // IF THE REFRESH FAILED, MEANING REFRESH IS NOT VALID, (ACCESS TOKEN EXPIRED) LOGOUT THE USER
          localStorage.clear(); // CLEAR STORAGE
          axios.post(utils._api(constant.logout), {}, {
            withCredentials: true,
            headers: {
              Accept: "application/json",
              'X-Skip-Token-Refresh': 'true'  // SKIP AXIOS INTERCEPTOR FOR THIS REQUEST
            },
          }).then(() => {
            window.location.href = '/login'; // REDIRECT TO LOGIN PAGE
          })
          return Promise.reject('Token could not be refreshed');
        }
      }
    }

    return config;
  },
  (error) => {
      return Promise.reject(error);
  }
);

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')

